import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GlobalComponent } from '../../global-component';
import { TokenStorageService } from './token-storage.service';
import { CurrentUser } from '../models/currentuser.models';
import { GenericService } from './generic.service';
import { ArchiveModel } from '../models/archive.models';

const BASE_URL = GlobalComponent.BASE_API_URL;
const AUTH_API = BASE_URL + GlobalComponent.AUTH_API;

@Injectable({
  providedIn: 'root'
})

export class ArchiveService {
  // private readonly ARCHIVE_API = 'http://localhost:1337/api/archives';

  currentuser!: CurrentUser;
  isvendor: boolean = false;
  vendorguid!: string;

  constructor(private http: HttpClient, private tokenService: TokenStorageService, private genericservice: GenericService) {
    this.currentuser = this.tokenService.getCurrentUser();
    this.isvendor = this.genericservice.getUserIsVendor();
    this.vendorguid = this.tokenService.getVendorGUID()!;
  }

  // Archive data
  archiveData(data: any) {
    return this.http.post<any>(BASE_URL+'archives', { data }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        return throwError(() => error);
      })
    );
  }

  // Retrieve archived users
  getArchivedData(skip: number, limit: number) {
    let url = "archives?filters[activestate][$eq]=true";
    if(this.isvendor) {
      url = "archives?filters[activestate][$eq]=true&filters[vendorguid][$eq]="+this.currentuser.user?.masterguid;
    } else {
      let guid = this.currentuser.user?.guid;
      if(this.currentuser.user?.role?.type == 'super_admin') {
        guid = this.currentuser.user?.guid;
      } else {
        guid = this.currentuser.user?.masterguid;
      }
      url = "archives?filters[activestate][$eq]=true&filters[clientguid][$eq]="+guid+"&filters[vendorguid][$eq]="+this.vendorguid;
    }
    url = url + "&pagination[page]=" + skip + "&paginations[pageSize]=" + limit;
    return this.http.get<any[]>(BASE_URL + url);
  }

  updateArchiveRecord(recordid: number, postdata: ArchiveModel) {
    return this.http.put<any[]>(BASE_URL + 'archives/' + recordid, { data : postdata });
  }
}
